export default (name) => {
  const trimmedName = (name || '').trim();
  const isFirstNameOnly = trimmedName.indexOf(' ') === -1;
  const firstName = isFirstNameOnly ? trimmedName : trimmedName.substring(0, trimmedName.indexOf(' '));
  const lastName = isFirstNameOnly ? '-' : trimmedName.substring(trimmedName.indexOf(' ') + 1);
  return [firstName, lastName];
};
